<template>
  <b-modal 
  :visible="show" 
  centered
  @hide="$emit('close')" 
  size="lg"
  ok-only
  hide-header-close
  title="Resultado da Consulta">

    <div v-if="notFound" class="text-center">
      <h4 class="text-danger">Não está na blacklist</h4>
      <p>Nenhum registro encontrado.</p>
    </div>

    <div v-else>
      <h4 class="text-success mb-3 text-center">Empresa na blacklist</h4>

      <b-table :items="paginatedData" :fields="fields" small>
        <template #cell(document)="data">
          {{ data.item.document | tax_id }}
        </template>
      </b-table>

      <b-pagination
        v-if="formattedData.length > perPage"
        v-model="currentPage"
        :total-rows="formattedData.length"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-1"
      />
      
    </div>

  </b-modal>
  
</template>
<script>
import {BTable, BModal, BPagination} from 'bootstrap-vue'
export default {
components: {BTable,BModal,BPagination},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => []
    },
    notFound: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentPage: 1,
      perPage: 5,
      fields: [
        { key: 'name', label: 'Nome' },
        { key: 'document', label: 'Documento' },
        { key: 'type', label: 'Tipo' },
        { key: 'reason', label: 'Motivo' },
        { key: 'source', label: 'Origem' },
        { key: 'created_at', label: 'Data' }
      ]
    }
  },

  computed: {
    formattedData() {
      return this.data.map(item => ({
        name: item.name,
        document: item.document,
        type: item.type,
        reason: item.reason,
        source: item.source,
        created_at: new Date(item.created_at).toLocaleDateString()
      }))
    },

    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage
      return this.formattedData.slice(start, start + this.perPage)
    }
  },

}
</script>